import { useBreedConstants } from "@/app/hooks/useBreedConstants";
import { useUtils } from "@/app/hooks/useUtils";
import clsx from "clsx";
import { Tooltip } from "react-tooltip";

const Breed: React.FC<{
  breedId: number;
  speciesId: string;
  className?: string;
  petBreed?:string
}> = (props) => {
  const { catBreeds, dogBreeds } = useBreedConstants();

  const { truncateString } = useUtils();

  const breedDetection = () => {
    if (props.speciesId === "1") {
      const filteredCatBreeds = dogBreeds.filter((catBreed) => catBreed.id === props?.breedId);

      return filteredCatBreeds[0]?.pet_breed;
    } 

    else if(props.speciesId==="15"){
      return props.petBreed;
    }
    else {
      const filteredCatBreeds = catBreeds.filter((catBreed) => catBreed.id === props?.breedId);

      return filteredCatBreeds[0]?.pet_breed;
    }
  };

  return (
    <>
      <span className={clsx(props?.className)} data-tooltip-id="petered" data-tooltip-content={breedDetection()}>
        {truncateString(breedDetection(), 20)}
      </span>
      <Tooltip id="petered" />
    </>
  );
};

export default Breed;
